import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NotificationSystem from 'react-notification-system';

import Header from './Header';
import socketConnector from 'sockets';

import { deleteNotification, addNotification } from 'actions/notifications/notifications';
import { getVessels } from 'actions/vessels/vessels';
import { getVesselClaims } from 'actions/vessels/claims';
import { getPorts } from 'actions/regions/ports';
import { logoutUser } from 'actions/users';

class Layout extends React.Component {
    constructor(props) {
        super(props);
    }

    connectSockets = false;
    _notificationSystem = null;

    UNSAFE_componentWillReceiveProps(nextProps) {
        nextProps.notifications.forEach((notification) => {
            this._notificationSystem.addNotification({
                ...notification,
                onAdd: () => {
                    return this.props.deleteNotification(notification);
                },
            });
        });
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;

        if (this.props.role === 'admin') {
            this.startSocket();
        }
    }

    startSocket() {
        const socket = socketConnector.connect(this.props);

        socket.on('admin:newVessel', (message) => {
            this.props.getVessels({});

            this.props.addNotification({
                title: 'New vessel was created',
                message: `Name - ${message.name}, imoNumber - ${message.imoNumber}`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 20,
                action: {
                    label: 'Show vessel',
                    callback: () => {
                        this.props.router.push(`/vessels/${message._id}`);
                    }
                }
            });
        });

        socket.on('admin:newClaimRightsToVessel', (message) => {
            this.props.getVesselClaims({});

            this.props.addNotification({
                title: 'Added new claims rights to vessel',
                message: `User - ${message.user.name}, Email user - ${message.user.email}, Vessel name - ${message.vessel.name}`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 9999,
                action: {
                    label: 'Show claims rights',
                    callback: () => {
                        this.props.router.push(`/vessels/claims`);
                    }
                }
            });
        });

        socket.on('admin:newPortChanges', (message) => {
            this.props.getPorts({});

            if (this.props.router.params.id === message._id) {
                this.props.router.push(`/regions/ports/approve/${message._id}`);
            }

            this.props.addNotification({
                title: 'Added changes to port',
                message: `Port name - ${message.name}, unLoCode - ${message.unLoCode}`,
                level: 'success',
                _id: Math.random(),
                autoDismiss: 30,
                action: {
                    label: 'Show port',
                    callback: () => {
                        this.props.router.push(`/regions/ports/approve/${message._id}`);
                        window.location.reload();
                    }
                }
            });
        });

        socket.on('admin:newIssueCreated', (message) => {
            this.props.addNotification({
                title: 'Warning',
                message: 'New issue was created',
                level: 'warning',
                _id: Math.random(),
                autoDismiss: 99,
                action: {
                    label: 'Show issue',
                    callback: () => {
                        window.open(`/issues/${message._id}`, "_blank")
                    }
                }
            });
        });
    }

    componentDidUpdate() {
        if (!this.props.isLogged && this.props.router.location.pathname != '/login') {
            socketConnector.disconnect();
            this.props.router.push('/login');
        }
    }

    render() {
        return (
            <Fragment>
                {
                    this.props.role !== 'user' ?
                        <Fragment>
                            <NotificationSystem ref='notificationSystem' />
                            <Header />
                            <div style={{ height: "calc(100% - 64px)", overflowY: "auto" }}>
                                {this.props.children}
                            </div>
                        </Fragment>
                        :
                        <div>
                            <h1>This user doesn't have permissions</h1>
                            <button onClick={this.props.logoutUser}>Change account</button>
                        </div>
                }
            </Fragment>
        );
    }
}

export default connect(
    ({ user, notifications }) => {
        return {
            isLogged: user.isLogged,
            userId: user.user._id,
            role: user.user.role,
            notifications: notifications.items,

        };
    },
    dispatch => bindActionCreators({
        deleteNotification,
        addNotification,
        getVessels,
        getVesselClaims,
        getPorts,
        logoutUser,
    }, dispatch),
)(Layout);



// WEBPACK FOOTER //
// ./app/components/Layouts/Layout.jsx